import { ArchitectureSearchQueryParameter } from "@/types/ArchitectureSearchQueryParameter";
import { ProductSearchQueryParameter } from "@/types/ProductSearchQueryParameter";

export const PriceRangeSliderMin = 0;
export const PriceRangeSliderMax = 1000000;
export const PriceRangeSliderStep = 1000;
export const PriceRangeSliderUnit = "円";

export const SizeRangeSliderMin = 0;
export const SizeRangeSliderMax = 8000;
export const SizeRangeSliderStep = 10;
export const SizeRangeSliderUnit = "mm";

export type PriceFormField = Pick<
  ProductSearchQueryParameter,
  "min_price" | "max_price"
>;

export type FloorSpaceFormField = Pick<
  ArchitectureSearchQueryParameter,
  "min_floor_space" | "max_floor_space"
>;

export type SizeFormField = Pick<
  ProductSearchQueryParameter,
  | "min_width"
  | "max_width"
  | "min_height"
  | "max_height"
  | "min_depth"
  | "max_depth"
>;

export type WidthFormField = Pick<
  ProductSearchQueryParameter,
  "min_width" | "max_width"
>;

export type HeightFormField = Pick<
  ProductSearchQueryParameter,
  "min_height" | "max_height"
>;

export type DepthFormField = Pick<
  ProductSearchQueryParameter,
  "min_depth" | "max_depth"
>;
